import { Component } from '@angular/core'

@Component({
  selector: 'se-po-profile-side-panel-docs',
  templateUrl: './profile-side-panel-docs.component.html',
  styleUrls: ['./profile-side-panel-docs.component.scss'],
  standalone: false,
})
export class ProfileSidePanelDocsComponent {
  public models: string[]
  public headers: any = {
    ProfileSidePanelComponent: [
      'Property',
      'Type',
      'Description'
    ]
  }

  public rows: any = {
    ProfileSidePanelComponent: [
      {
        Property: '@Input() headerLink',
        Type: 'string',
        Description: 'Link header title to given url'
       },
       {
        Property: '@Input() menuOptions',
        Type: 'SeFeMenuOptions',
        Description: 'Menu options if menu desired in side panel'
       },
      {
       Property: '@Input() profile',
       Type: 'UserProfile',
       Description: 'Profile to display'
      },
      {
        Property: '@Output() closePanel',
        Type: 'void',
        Description: 'The side panel has been closed'
      }
    ]
  }

  constructor() {
    this.models = Object.keys(this.headers)
  }
}
